"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gammaCorrection = gammaCorrection;

var _transformImage = require("./transformImage");

var _exceptions = require("../exceptions");
/**
 * Applies gamma correction to the given image
 *
 * @param {RgbaImageBuffer} imgBuffer Image to transform
 * @param {number} gammaValue Gamma value for gamma correction
 * @returns {RgbaImageBuffer} Transformed image
 */


function gammaCorrection(imgBuffer, gammaValue) {
  if (gammaValue < 0) {
    throw new _exceptions.ImageOperationException("GammaCorrectionException", "Invalid gamma value, gamma should be equal or greater than 0.");
  } // The gamma operation needs to be applied to each color dimension normalized
  // in a range [0,1] (at least in the case of RGB)


  var correctDim = function correctDim() {
    return function (value) {
      return Math.pow(value / 255, gammaValue) * 255;
    };
  };

  var lookupTable = (0, _transformImage.createLookupTable)(correctDim);
  return (0, _transformImage.applyLookupTable)(imgBuffer, lookupTable);
}